import Axios from "../helper/appConfig";

  export async function getBillCalculation(payload) {
    return await Axios.post("api/bills/billdetail", payload);
  }